import React from 'react';
import translator from '../../../common/translate';
import AuthService from '../../../Auth/AuthService';
import ExternalLink from '../../ExternalLink';
import SangomaLogo from '../../../assets/images/sangoma-logo.png';
import LoggedOutIcon from '../../../assets/images/logged-out-icon.svg';
import AccessDeniedIcon from '../../../assets/images/access-denied-icon.svg';
import EmblemLarge from './../../EmblemComponent';
import './logout.style.css';

// Not getLoginUrlToCurrentRoute: no current path is sent along, here the user must end up on the root page
const handleLogin = () => window.location.assign(AuthService.getLoginUrl());

// The icon and the message depend on the query parameters the backend adds when it sends the user here
const getPageContent = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('reason') === 'access_denied') {
    return {
      icon: AccessDeniedIcon,
      messageKey: 'msg_you_are_not_authorized_to_use_rocket',
      hintKey: 'msg_please_contact_your_sangoma_sales_representative',
    };
  }

  if (params.get('success') === 'true') {
    return { icon: LoggedOutIcon, messageKey: 'msg_you_have_logged_out', hintKey: null };
  }

  return { icon: LoggedOutIcon, messageKey: null, hintKey: null };
};

export default function LogoutComponent() {
  const { icon, messageKey, hintKey } = getPageContent();

  return (
    <div className="logout-page">
      <div className="logout-page-left-part">
        <header className="logout-page-left-part-header">
          <img className="logout-page__logo" src={SangomaLogo} alt="Sangoma" />
        </header>
        <main className="logout-page-left-part-main">
          <img className="logout-page__icon" src={icon} alt="" />
          {messageKey && <p className="logout-page__message">{translator.getMessage(messageKey)}</p>}
          {hintKey && <p className="logout-page__hint">{translator.getMessage(hintKey)}</p>}
          <button id="logout-page-login" className="large logout-page__login-btn" onClick={handleLogin}>
            {translator.getMessage('msg_login_with_sangoma_sso')}
          </button>
        </main>
        <footer className="logout-page-left-part-footer">
          <div>
            <ExternalLink
              path="https://sangoma.com/terms"
              title={translator.getMessage('msg_about_dialog_link_terms_of_use')}
            />
            &nbsp;|&nbsp;
            <ExternalLink
              path="https://sangoma.com/privacy-policy"
              title={translator.getMessage('msg_about_dialog_link_privacy_policy')}
            />
          </div>
          <div>
            &copy;{new Date().getFullYear()}&nbsp;{translator.getMessage('msg_sangoma_all_rights_reserved')}
          </div>
        </footer>
      </div>
      <div className="landing-right-part">
        <EmblemLarge />
      </div>
    </div>
  );
}
